// extracted by mini-css-extract-plugin
export default {"container":"_J-z","dimension":"aK-z","dimensionLabels":"bK-z"};